import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import CurrentLayerPanelForm from "./CurrentLayerPanelForm"
import SelectedElementsForm from "./SelectedElementsForm"

/* Protopia Ecosystem component */
export interface ICurrentLayerPanelProps {
    
}
const CurrentLayerPanel = (props: ICurrentLayerPanelProps): JSX.Element => {
    const { 
        selectedElements,  
    }	= useLandingStore((state: ILandingStore) => state)  
    
    return selectedElements.length 
        ?
        <SelectedElementsForm />
        :
        <CurrentLayerPanelForm />
}
export default CurrentLayerPanel